import $x from '@/utils/$x';

/**
 * 新增-推广页
 * @param {*} params
 * @returns
 */
export function promotionAdd(params) {
  return $x.post(`/v1/litta/promotion/add`, params);
}

/**
 * 更新-推广页
 * @param {*} params
 * @returns
 */
export function promotionModify(params) {
  return $x.post(`/v1/litta/promotion/update`, params);
}

/**
 * 查询DM明细 (id查询)
 * @param {*} params
 * @returns
 */
export function queryPromotionById(params) {
  return $x.post(`/v1/litta/promotion/queryPromotionById`, params);
}

/**
 * 查询调度规则
 * @param {*} params
 */
export async function queryRuleNames(params) {
  return $x.post(`/schedule/admin/ruleNames`, params);
}

/**
 * 欢迎语下拉框
 */
export async function queryGreetListBox(params) {
  return $x.post(`/v1/litta/greet/listBox`, params);
}

/**
 * 会员商品列表信息
 * @param {*} params
 * @returns
 */
export async function queryLittaGoodsInfoList(params) {
  return $x.post('/pergamonGoods/queryLittaGoodsInfoList', params);
}

export async function queryPromotionList(params) {
  return $x.post(`/sidebar/queryPromotionList`, params);
}

/**
 * 获取企业推广模块配置 http://172.16.150.60:7700/#/view/d8xdAWG8
 * @param {*} params
 * @returns
 */
export async function getEnterpriseMarketingConfig(params) {
  return $x.post(`/enterprise/config/getEnterpriseMarketingConfig`, params);
}

/**
 * 保存推广配置 http://172.16.150.60:7700/#/view/q2RLRxmX
 * @param {*} params
 * @returns
 */
export async function enableMarketingConfig(params) {
  return $x.post(`/enterprise/config/enableMarketingConfig`, params);
}

export async function onlineOrOffLinePromotion(params) {
  return $x.post(`/v1/litta/promotion/onlineOrOffLinePromotion`, params);
}
export async function deletePromotion(params) {
  return $x.post(`/v1/litta/promotion/delete`, params);
}

/**
 * 强制打开/关闭商品的自动续费开关
 * @param {*} params requestData: { autoRenew }  0:否 1:是；tenantId 可选，不传则全量
 * @returns
 */
export async function forceOperateAutoRenewGoods(params) {
  return $x.post(`/v1/litta/promotion/forceOperateAutoRenewGoods`, params);
}

/**
 * 获取自动续费模板
 * @param {*} params
 * @returns
 */
export async function getRenewAgreementTemplates(params) {
  return $x.post('/renew/agreement/templates', params);
}
/**
 * 渠道列表
 * @param {*} params
 * @returns
 */
export async function getChannelCodeList(params) {
  return $x.post('/v1/litta/channel/getList ', params);
}

/**
 * 分销列表 KOL
 * @param {*} params
 * @returns
 */
export async function getKOLPage(params) {
  return $x.post('/third-order/kol/page', params);
}

/**
 * 分销列表 KOL 删除
 * @param {*} params
 * @returns
 */
export async function deleteKol(params) {
  return $x.post('/third-order/kol/del', params);
}
/**
 * 分销列表 KOL 保存
 * @param {*} params
 * @returns
 */
export async function saveKol(params) {
  return $x.post('/third-order/kol/save', params);
}
/**
 * 分销列表 KOL 查询
 * @param {*} params
 * @returns
 */
export async function getKolById(params) {
  return $x.post('/third-order/kol/getById', params);
}
/**
 * 分销列表 KOL 同步
 * @param {*} params
 * @returns
 */
export async function syncKolList(params) {
  return $x.post('/third-order/kol/sync-sharer', params);
}
/**
 * 保存kol调度
 * @param {*} params
 * @returns
 */
export async function saveKolSchedule(params) {
  return $x.post('/third-order/kol/saveKolSchedule', params);
}
/**
 * 更新kol调度
 * @param {*} params
 * @returns
 */
export async function updateKolSchedule(params) {
  return $x.post('/third-order/kol/updateKolSchedule', params);
}
/**
 * 删除kol调度
 * @param {*} params
 * @returns
 */
export async function deleteKolSchedule(params) {
  return $x.post('/third-order/kol/deleteKolSchedule', params);
}
/**
 * 查询kol调度
 * @param {*} params
 * @returns
 */
export async function queryKolSchedule(params) {
  return $x.post('/third-order/kol/queryKolSchedule', params);
}
/**
 * api充值商品列表
 * @param {*} params
 * @returns
 */
export async function apiGoodsList(params) {
  return $x.post('/v1/litta/order/promotion/api-order-goods-list', params);
}
/**
 * api充值商品 新增
 * @param {*} params
 * @returns
 */
export async function apiGoodsAdd(params) {
  return $x.post('/v1/litta/order/promotion/api-order-goods-add', params);
}
/**
 * api充值商品 删除
 * @param {*} params
 * @returns
 */
export async function apiGoodsDel(params) {
  return $x.post('/v1/litta/order/promotion/api-order-goods-del', params);
}
